module.exports = __webpack_public_path__ + "img/output-11.93167ccd.png";